import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as departApi from '../../lib/api/department';

const [LIST_DEPART, LIST_DEPART_SUCCESS, LIST_DEPART_FAILURE] =
  createRequestActionTypes('depart/LIST_DEPART');

export const listDeparts = createAction(
  LIST_DEPART,
  (searchData) => searchData,
);
const listDepartsSaga = createRequestSaga(
  LIST_DEPART,
  departApi.getListDepartments,
);

const [TREE_DEPART, TREE_DEPART_SUCCESS, TREE_DEPART_FAILURE] =
  createRequestActionTypes('depart/TREE_DEPART');

export const treeDeparts = createAction(
  TREE_DEPART,
  (searchData) => searchData,
);
const treeDepartsSaga = createRequestSaga(
  TREE_DEPART,
  departApi.getDepartments,
);

const UNLOAD_TREE_DEPARTS = 'depart/UNLOAD_TREE_DEPARTS';
export const unloadTreeDeparts = createAction(UNLOAD_TREE_DEPARTS);

export function* departsSaga() {
  yield takeLatest(LIST_DEPART, listDepartsSaga);
  yield takeLatest(TREE_DEPART, treeDepartsSaga);
}

const initialState = {
  list: null,
  departs: null,
  error: null,
};

const departs = handleActions(
  {
    [LIST_DEPART_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      list: data.list,
      error: null,
    }),
    [LIST_DEPART_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),

    [TREE_DEPART_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      departs: data.info,
      error: null,
    }),
    [TREE_DEPART_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_TREE_DEPARTS]: () => initialState,
  },
  initialState,
);

export default departs;
